export default __webpack_public_path__ + "static/stand-designer-icon-12f6aa7c7a0a67c0db3e0b58517beb51.svg";